import { AbstractDialogContent } from '@abstracts/dialog/dialog-content';
import { Component, Injector, Input, OnInit } from '@angular/core';
import { ChargingStationPublicChargeRequest } from '@dto/ocpp/chargingStationPublicChargeRequest';
import { ChargingStation } from '@models/charging-station';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ChargingStationsService } from '@services/entity/charging-stations.service';
import { HttpState } from 'src/app/types/HttpState';


@Component({
  selector: 'app-enable-public-charge-dialog-content',
  templateUrl: './enable-public-charge-dialog-content.component.html',
  styleUrls: ['./enable-public-charge-dialog-content.component.css']
})
export class EnablePublicChargeDialogContentComponent extends AbstractDialogContent implements OnInit {

  public className = 'EnablePublicChargeDialogContentComponent';

  @Input() private chargingStation: ChargingStation;
  @Input() private currentStatus: boolean;

  public isResetPressed: boolean = false;
  public state: HttpState = '';

  constructor(
    public activeModal: NgbActiveModal,
    private chargingStationService: ChargingStationsService,
    injector: Injector) {
    super(activeModal, injector);
  }

  onConfirmClick() {
    this.isResetPressed = true;
    this.state = 'loading';

    var publicChargeRequest: ChargingStationPublicChargeRequest = {
      publicCharging: true
    }

    if (this.currentStatus) {
      publicChargeRequest.publicCharging = false;
    }

    this.chargingStationService.configurePublicCharge(this.chargingStation.id, publicChargeRequest).subscribe(result => {
      if (result.status) {
        this.state = 'success';
      }
      else {
        this.state = 'failure';
      }
    }, error => {
        this.state = 'failure';
    });
  }

  onCancelClick() {
    this.activeModal.close({ state: 'failure' });
  }

  onOkClick() {
    this.activeModal.close({ state: this.state });
  }

}
